import {RatingStars} from '@frontend/components/RatingStars'
import type {ReviewsListRatingBreakdownItemData} from '@frontend/modules/public/shared/reviews/ReviewsModuleTypes'
import clsx from 'clsx'
import {Progress} from 'swayok-react-mdb-ui-kit/components/Progress/Progress'
import {ProgressBar} from 'swayok-react-mdb-ui-kit/components/Progress/ProgressBar'

interface Props {
    ratingBreakdown: ReviewsListRatingBreakdownItemData[] | null
    reviewsCount?: number
    noProgressBar?: boolean
    className?: string
}

// Распределение оценок рейтинга пользователя/исполнителя услуг.
export function ReviewsListRatingBreakdown(props: Props) {

    const {
        ratingBreakdown,
        reviewsCount = 0,
        noProgressBar,
        className = 'mt-1',
    } = props

    if (!ratingBreakdown) {
        return null
    }

    return (
        <table
            className={clsx(
                'table table-borderless table-sm',
                noProgressBar ? 'w-auto' : '',
                className
            )}
        >
            <tbody>
                {ratingBreakdown.map((rateInfo: ReviewsListRatingBreakdownItemData, index: number) => (
                    <tr key={'rating-summary-' + index}>
                        <td className="ps-0 pe-3 py-1 align-middle">
                            <RatingStars
                                rating={rateInfo.rating}
                                starSize={20}
                                inactiveIconColor="light-gray"
                            />
                        </td>
                        {!noProgressBar && (
                            <td className="full-width px-0 py-1 align-middle">
                                <Progress height={6}>
                                    <ProgressBar
                                        currentValue={rateInfo.count}
                                        maxValue={reviewsCount}
                                        color="dark"
                                    />
                                </Progress>
                            </td>
                        )}
                        <td
                            className={clsx(
                                'pe-0 py-1 align-middle text-end',
                                noProgressBar ? 'ps-1' : 'ps-4'
                            )}
                        >
                            {rateInfo.count}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    )
}
